export function isMangoFeatureEnabled() {
  const value = String(process.env.REACT_APP_ENABLE_MANGO_BOOKING || "")
    .trim()
    .toLowerCase();

  if (!value) return true;

  return !["false", "0", "off", "no"].includes(value);
}
